(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/hooks/use-sport-filter.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/hooks/use-sport-filter.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useCallback,
  useEffect,
  useMemo,
  useState
} = React;
const useSportFilter = productSetting => {
  const [filters, setFilters] = useState({});
  useEffect(() => {
    setFilters({});
  }, [productSetting]);
  const toggleSport = useCallback((sportType, checked) => {
    setFilters(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [sportType]: Boolean(checked)
    }));
  }, []);
  const anyActive = useMemo(() => Object.values(filters).some(Boolean), [filters]);
  const isVisible = useCallback(sport => {
    if (!productSetting || !productSetting.allowFiltering) {
      return true;
    }
    if (!anyActive) {
      return true;
    }
    if (sport && sport.type > 0) {
      return Boolean(filters[sport.type]);
    }
    return true;
  }, [productSetting, filters, anyActive]);
  return {
    filters,
    toggleSport,
    isVisible
  };
};
setGlobal('svs.tt.hooks.useSportFilter', useSportFilter);

 })(window);